import { createSlice, PayloadAction } from "@reduxjs/toolkit"

import { UserAccount } from "@modules/ClientAuthorization/common/interfaces"
import { createNonVerifiedUserAccount, isVerified } from "@modules/ClientAuthorization/common/utils"
import { USER_ACCOUNT_LOADING_STATUS } from "@modules/ClientAuthorization/Default/common/constant"

interface UserState {
    clientHash: string | null
    psyHash: string | null
    client: UserAccount
    clientIsLoading: USER_ACCOUNT_LOADING_STATUS
    isClientVerified: boolean
}

const initialState: UserState = {
    clientHash: null,
    psyHash: null,
    client: createNonVerifiedUserAccount(),
    clientIsLoading: USER_ACCOUNT_LOADING_STATUS.IDLE,
    isClientVerified: false,
}

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setClientHash(state, action: PayloadAction<string>) {
            state.clientHash = action.payload
        },
        setPsyHash(state, action: PayloadAction<string>) {
            state.psyHash = action.payload
        },
        setClient(state, action: PayloadAction<UserAccount>) {
            state.client = action.payload
            state.isClientVerified = isVerified(action.payload)
        },
        setClientIsLoading(state, action: PayloadAction<USER_ACCOUNT_LOADING_STATUS>) {
            state.clientIsLoading = action.payload
        },
    },
})

export const userReducer = userSlice.reducer

export const { setClientHash, setPsyHash, setClient, setClientIsLoading } = userSlice.actions
